<template>
  <div>
    <!-- Gurudwara list -->
    <div class="p-6 pt-0">
      <div v-if="!isAddModalShow && !isEditModalShow && !isSlotMasterModalShow">
        <vs-table
          id="service-list"
          class="vs-con-loading__container"
          stripe
          :sst="true"
          maxHeight="800px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          :total="FilteredCount"
          :max-items="length"
          search
          :data="records"
        >
          <template slot="header">
            <div class="mb-2 flex items-center">
              <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                  <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">
                        {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                        -
                        {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                        of {{ total || 0 }}
                      </span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="handleChangeLength(10)">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(20)">
                        <span>20</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(50)">
                        <span>50</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(100)">
                        <span>100</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
              <div class="flex flex-wrap items-center">
                <!-- Custom Pagination -->
                <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
              </div>
              <vs-button v-if="canCreateService" @click="toggleAddModal" color="primary" size="default" style="padding: 12px 30px">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add {{ module_name }}</vs-button
              >

            <div
              @click="slotMasterPage"
              class="btn-add-new ml-4 p-3 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">View Bookings</span>
            </div>
            </div>
          </template>

          <template slot="thead">
            <vs-th>Sr#</vs-th>
            <vs-th>{{ module_name }} Name</vs-th>
            <vs-th>Currency</vs-th>
            <vs-th v-if="canEditService">{{ isSuperAdmin ? 'Active' : 'Visible' }}</vs-th>
            <vs-th v-if="canEditService || canDeleteService || canViewService">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer" v-if="canEditService" @click.stop="toggleEditModal(tr)" v-tooltip="{ content: `Edit ${tr.service.service_name}` }">{{
                  tr.service.service_name || '-'
                }}</span>
                <span v-else>{{ tr.service.service_name || '-' }}</span>
              </vs-td>
              <vs-td>{{ tr.currency || 'INR' }}</vs-td>
              <vs-td v-if="canEditService">
                <span v-if="isSuperAdmin">{{ tr.is_active ? 'Yes' : 'No' }}</span>
                <vs-switch
                  v-else
                  icon-pack="feather"
                  vs-icon-on="icon-check-circle"
                  vs-icon-off="icon-slash"
                  color="primary"
                  :value="tr.is_active"
                  @click.stop="updateStatus(tr._id, !tr.is_active)"
                >
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td>
              <vs-td v-if="canEditService || canDeleteService || canViewService">
                <div class="inline-flex">
                  <vx-tooltip
                    v-if="canEditService || canViewService"
                    :text="`${canEditService ? 'Edit' : 'View'} ${module_name}`"
                  >
                    <feather-icon
                      @click.stop="toggleEditModal(tr)"
                      :icon="canEditService ? 'EditIcon' : 'EyeIcon'"
                      svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer"
                    />
                  </vx-tooltip>
                  <vx-tooltip v-if="canDeleteService" :text="`Delete ${module_name}`">
                    <feather-icon @click.stop="deleteRecord(tr._id)" icon="TrashIcon" svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <!-- Add modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isAddModalMounted" :showModal.sync="isAddModalShow" :action_name="'Add'" />
      <!-- Edit modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isEditModalMounted" :showModal.sync="isEditModalShow" :selectedRecordId="selectedRecordId" :selectedRecordData="selectedRecordData" :action_name="'Update'" />
      <!-- Slot Master modal -->

      <slot-master-modal :module_name="module_name" @update-data="getData" v-if="isSlotMasterModalMounted" :showModal.sync="isSlotMasterModalShow" :selectedRecordId="selectedRecordId" :action_name="'Update'" />

      <vs-popup
        :active.sync="showBankDetailsModal"
        title="Update Bank Details"
        class="bank-details-modal"
        :button-cancel="false"
        :button-accept="false"
      >
      <div class="px-6 py-4 space-y-5">
          <h3 class=" text-gray-600 font-bold leading-relaxed">
            Gurudwara admin has not added the bank account details yet. Please provide the required information below to activate this service.
          </h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <vs-input
              v-model="bankDetailsForm.name"
              label="Gurudwara Name *"
              placeholder="Enter Gurudwara name"
              class="w-full"
              @input="handleBankFieldInput('name')"
            />
            <span v-if="bankDetailsErrors.name" class="text-danger text-sm mt-1 block">{{ bankDetailsErrors.name }}</span>
          </div>
          <div>
            <vs-input
              v-model="bankDetailsForm.email"
              label="Email *"
              placeholder="Enter contact email"
              class="w-full"
              @input="handleBankFieldInput('email')"
            />
            <span v-if="bankDetailsErrors.email" class="text-danger text-sm mt-1 block">{{ bankDetailsErrors.email }}</span>
          </div>
          <div>
            <vs-input
              v-model="bankDetailsForm.phone"
              label="Phone *"
              placeholder="Enter contact number"
              class="w-full"
              @input="handleBankFieldInput('phone')"
            />
            <span v-if="bankDetailsErrors.phone" class="text-danger text-sm mt-1 block">{{ bankDetailsErrors.phone }}</span>
          </div>
          <div>
            <label class="vs-input--label block">Business Type *</label>
            <select-2
              class="w-full"
              name="business_type"
              placeholder="Select business type"
              :options="businessTypeOptions"
              :multiple="false"
              :ssr="false"
              :clearable="false"
              :value="bankDetailsForm.business_type"
              @input="onBusinessTypeChange"
            />
            <span v-if="bankDetailsErrors.business_type" class="text-danger text-sm mt-1 block">{{ bankDetailsErrors.business_type }}</span>
          </div>
        </div>
          <div>
            <vs-input
              v-model="bankDetailsForm.account_number"
              label="Account Number *"
              placeholder="Enter account number"
              class="w-full"
            @input="handleBankFieldInput('account_number')"
            />
            <span v-if="bankDetailsErrors.account_number" class="text-danger text-sm mt-1 block">{{ bankDetailsErrors.account_number }}</span>
          </div>
          <div>
            <vs-input
            v-model="bankDetailsForm.ifsc"
              label="IFSC Code *"
              placeholder="Enter IFSC code"
              class="w-full"
            @input="handleBankFieldInput('ifsc')"
            />
          <span v-if="bankDetailsErrors.ifsc" class="text-danger text-sm mt-1 block">{{ bankDetailsErrors.ifsc }}</span>
          </div>
          <div class="flex justify-end gap-3 pt-2">
            <vs-button type="border" @click="closeBankDetailsModal">Cancel</vs-button>
            <vs-button type="filled" color="primary" class="vs-con-loading__container" id="save-bank-details" :disabled="isSavingBankDetails" @click="submitBankDetails">
              Save & Retry Activation
            </vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import actionModal from './action'
import slotMasterModal from './slotMaster'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'Service-List',
  components: { actionModal, slotMasterModal, Select2 },
  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Service',
    route_slug: 'service',
    // Add modal
    isAddModalMounted: false,
    isAddModalShow: false,
    isSlotMasterModalMounted: false,
    isSlotMasterModalShow: false,
    // Edit modal
    isEditModalMounted: false,
    isEditModalShow: false,
    selectedRecordId: null,
    selectedRecordData: null,
    showBankDetailsModal: false,
    bankDetailsForm: {
      name: '',
      email: '',
      phone: '',
      business_type: '',
      account_number: '',
      ifsc: ''
    },
    bankDetailsErrors: {
      name: '',
      email: '',
      phone: '',
      business_type: '',
      account_number: '',
      ifsc: ''
    },
    businessTypeOptions: [
      { label: 'Religious Trust', value: 'religious_trust' },
      { label: 'Society', value: 'society' },
      { label: 'Non Profit', value: 'non_profit' }
    ],
    isSavingBankDetails: false,
    pendingStatusChange: null
  }),

  /** computed */
  computed: {
    ...mapState('service', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug', 'checkRolesByIds']),
    isSuperAdmin() {
      return this.checkRolesByIds(['super_admin', 'admin'])
    },
    portalServiceRoles() {
      return ['gurudwara-admin', 'gurudwara_admin', 'committee-admin', 'committee_admin', 'admin', 'support_administrator']
    },
    canCreateService() {
      return (
        this.checkPermissionSlug(['available_service_create', 'gurudwara_service_create', 'service_create']) ||
        this.checkRolesByIds(this.portalServiceRoles)
      )
    },
    canEditService() {
      return (
        this.checkPermissionSlug(['available_service_edit', 'gurudwara_service_edit', 'service_edit']) ||
        this.checkRolesByIds(this.portalServiceRoles)
      )
    },
    canViewService() {
      return (
        this.checkPermissionSlug(['available_service_view', 'gurudwara_service_view', 'service_view', 'gurudwara_service_booking_view']) ||
        this.checkRolesByIds(this.portalServiceRoles)
      )
    },
    canDeleteService() {
      return (
        this.checkPermissionSlug(['available_service_delete', 'gurudwara_service_delete', 'service_delete']) ||
        this.checkRolesByIds(['admin', 'support_administrator'])
      )
    },
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('service', {
      get: 'get',
      delete: 'delete'
    }),

    /** toggle modal */
    toggleAddModal() {
      this.isAddModalMounted = true
      this.isAddModalShow = true
      this.selectedRecordId = null
    },

    slotMasterPage() {
      this.isSlotMasterModalMounted = true
      this.isSlotMasterModalShow = true
    },
    // Edit
    toggleEditModal(record) {
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecordId = record._id
      this.selectedRecordData = record
      console.log('selectedRecordData:', this.selectedRecordData)
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search,
        gurudwara: this.$route.params.id
      })
    },

    /** Delete Gurudwara Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete Gurudwara API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** updateStatus API */
    updateStatus(id, status) {
      this.$store
        .dispatch('service/updateStatus', {
          id,
          status
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const record = Array.isArray(this.records) ? this.records.find((rec) => rec._id === id) : null
          if (record) {
            this.$set(record, 'is_active', !status)
          }
          const { message } = err
          const requiresBankDetails = typeof message === 'string' && message.includes('Gurudwara admin has not added their Bank details yet')
          if (requiresBankDetails) {
            this.pendingStatusChange = { id, status }
            this.openBankDetailsModal()
          } else {
            this.$vs.notify({
              title: 'Error',
              text: message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              position: 'top-center',
              time: 5000,
              color: 'primary'
            })
          }
        })
    },
    openBankDetailsModal() {
      Object.assign(this.bankDetailsErrors, {
        name: '',
        email: '',
        phone: '',
        business_type: '',
        account_number: '',
        ifsc: ''
      })
      this.showBankDetailsModal = true
    },
    closeBankDetailsModal() {
      this.showBankDetailsModal = false
      this.resetBankDetailsForm()
      this.pendingStatusChange = null
    },
    resetBankDetailsForm() {
      Object.assign(this.bankDetailsForm, {
        name: '',
        email: '',
        phone: '',
        business_type: '',
        account_number: '',
        ifsc: ''
      })
      Object.assign(this.bankDetailsErrors, {
        name: '',
        email: '',
        phone: '',
        business_type: '',
        account_number: '',
        ifsc: ''
      })
    },
    onBusinessTypeChange(item) {
      this.bankDetailsForm.business_type = item && item.value ? item.value : ''
      if (this.bankDetailsForm.business_type) {
        this.bankDetailsErrors.business_type = ''
      }
    },
    handleBankFieldInput(field) {
      if (field === 'phone') {
        this.bankDetailsForm.phone = this.sanitizeNumericInput(this.bankDetailsForm.phone, 10)
      } else if (field === 'account_number') {
        this.bankDetailsForm.account_number = this.sanitizeNumericInput(this.bankDetailsForm.account_number, 18)
      } else if (field === 'ifsc') {
        this.bankDetailsForm.ifsc = this.formatIfsc(this.bankDetailsForm.ifsc)
      } else if (field === 'email') {
        this.bankDetailsForm.email = (this.bankDetailsForm.email || '').trim()
      } else if (field === 'name') {
        this.bankDetailsForm.name = (this.bankDetailsForm.name || '').trimStart()
      }
      if (this.bankDetailsErrors[field]) {
        this.bankDetailsErrors[field] = ''
      }
    },
    sanitizeNumericInput(value = '', maxLength = null) {
      const digitsOnly = (value || '').replace(/\D/g, '')
      return typeof maxLength === 'number' ? digitsOnly.slice(0, maxLength) : digitsOnly
    },
    formatIfsc(value = '') {
      return (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 11)
    },
    validateBankDetailsForm() {
      this.bankDetailsErrors.name = ''
      this.bankDetailsErrors.email = ''
      this.bankDetailsErrors.phone = ''
      this.bankDetailsErrors.business_type = ''
      this.bankDetailsErrors.account_number = ''
      this.bankDetailsErrors.ifsc = ''

      this.bankDetailsForm.phone = this.sanitizeNumericInput(this.bankDetailsForm.phone, 10)
      this.bankDetailsForm.account_number = this.sanitizeNumericInput(this.bankDetailsForm.account_number, 18)
      this.bankDetailsForm.ifsc = this.formatIfsc(this.bankDetailsForm.ifsc)

      const trimmed = {
        name: (this.bankDetailsForm.name || '').trim(),
        email: (this.bankDetailsForm.email || '').trim(),
        phone: (this.bankDetailsForm.phone || '').trim(),
        business_type: (this.bankDetailsForm.business_type || '').trim(),
        account_number: (this.bankDetailsForm.account_number || '').trim(),
        ifsc: (this.bankDetailsForm.ifsc || '').trim()
      }

      if (!trimmed.name) {
        this.bankDetailsErrors.name = 'Gurudwara name is required'
      }
      if (!trimmed.email) {
        this.bankDetailsErrors.email = 'Email is required'
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(trimmed.email)) {
        this.bankDetailsErrors.email = 'Enter a valid email address'
      }
      if (!trimmed.phone) {
        this.bankDetailsErrors.phone = 'Phone is required'
      } else if (!/^\d{10}$/.test(trimmed.phone)) {
        this.bankDetailsErrors.phone = 'Enter a valid 10-digit phone number'
      }
      if (!trimmed.business_type) {
        this.bankDetailsErrors.business_type = 'Business type is required'
      }
      if (!trimmed.account_number) {
        this.bankDetailsErrors.account_number = 'Account number is required'
      } else if (!/^\d{9,18}$/.test(trimmed.account_number)) {
        this.bankDetailsErrors.account_number = 'Enter a valid account number (9-18 digits)'
      }
      if (!trimmed.ifsc) {
        this.bankDetailsErrors.ifsc = 'IFSC code is required'
      } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(trimmed.ifsc)) {
        this.bankDetailsErrors.ifsc = 'Enter a valid IFSC code (e.g. ABCD0EF1234)'
      }

      return !Object.values(this.bankDetailsErrors).some(Boolean)
    },
    async submitBankDetails() {
      if (!this.validateBankDetailsForm()) return
      const gurudwaraId = this.$route && this.$route.params ? this.$route.params.id : null
      if (!gurudwaraId) {
        this.$vs.notify({
          title: 'Error',
          text: 'Unable to determine Gurudwara ID.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const payload = {
        name: this.bankDetailsForm.name.trim(),
        email: this.bankDetailsForm.email.trim(),
        phone: this.bankDetailsForm.phone.trim(),
        business_type: this.bankDetailsForm.business_type,
        bank_account: {
          account_number: this.bankDetailsForm.account_number.trim(),
          ifsc: this.bankDetailsForm.ifsc.trim()
        }
      }
      this.isSavingBankDetails = true
      this.$vs.loading({ container: '#save-bank-details', scale: 0.45 })
      let submissionSucceeded = false
      try {
        await this.$http.post(`admin/gurudwara/create-submerchant/${gurudwaraId}`, payload)
        this.$vs.notify({
          title: 'Success',
          text: 'Bank details submitted successfully.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        submissionSucceeded = true
        if (this.pendingStatusChange) {
          const { id, status } = this.pendingStatusChange
          this.pendingStatusChange = null
          this.updateStatus(id, status)
        }
      } catch (error) {
        const message = (error && error.response && error.response.data && error.response.data.message) || error.message || 'Failed to update bank details'
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      } finally {
        this.isSavingBankDetails = false
        try {
          this.$vs.loading.close('#save-bank-details > .con-vs-loading')
        } catch (e) {
          // no-op
        }
        if (submissionSucceeded) {
          this.closeBankDetailsModal()
        }
      }
    }
  },

  /** Watchers */
  watch: {
    // listLoading() {
    //   if (this.listLoading) {
    //     this.$vs.loading({
    //       container: '#service-list',
    //       scale: 0.45
    //     })
    //   } else {
    //     this.$vs.loading.close('#service-list > .con-vs-loading')
    //   }
    // },
    page() {
      this.getData()
    },
    // Add modal
    isAddModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddModalMounted = false
          }, 0)
        }
      }
    },

    // Edit modal
    isEditModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditModalMounted = false
            this.selectedRecordData = null
          }, 0)
        }
      }
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
.bank-details-modal .vs-popup {
  overflow: visible;
}

.bank-details-modal .vs-popup--content {
  overflow: visible;
}
</style>
